import React, { useState , forwardRef ,useEffect} from 'react';
import {main_url} from  './basefile';

import {
  Typography,
  Divider,
  Grid,
  TextField,
  MenuItem,
  Box,
  RadioGroup,
   Radio,
    FormControlLabel,
    Button,
    Tab,
    Tooltip
} from '@mui/material';

const TimelineSection = ({ projectId, totalvisits , onClose })  => {


  const [formData, setFormData] = useState({
    number_of_visits: totalvisits,
  });

 const testfunc = () => {
    // Your POST logic here
    alert("call from parent...");
  };

  
   //alert(projectId);

  const allResponses = [];

  const [visits, setVisits] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'number_of_visits') {
      const num = parseInt(value) || 0;
      const newVisits = Array.from({ length: num }, (_, i) => visits[i] || {
        schedule_type: 'static',   // New field
        //date: '',
        date: i === 0 ? new Date().toISOString().slice(0, 10) : '',
        interval: '',
        buffer: '',
      });
      setVisits(newVisits);
      setFormData(prev => ({ ...prev, [name]: value }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleVisitChange = (index, field, value) => {
    const updatedVisits = [...visits];
    updatedVisits[index][field] = value;

     // If switching to dynamic, clear related fields
  if (field === 'schedule_type' && value === 'dynamic') {

    updatedVisits[index].planned_date = '';
    updatedVisits[index].actual_date = '';
    updatedVisits[index].interval = '';
    updatedVisits[index].buffer = '';
  }

  //f interval is changed and not the first visit, calculate date
  if (field === 'interval' && index > 0 && updatedVisits[index].schedule_type === 'static') {

    
    const prevDateStr = updatedVisits[index - 1]?.date;
    const intervalDays = parseInt(value);

    if (prevDateStr && !isNaN(intervalDays)) {
      const prevDate = new Date(prevDateStr);
      prevDate.setDate(prevDate.getDate() + intervalDays);
      const nextDate = prevDate.toISOString().slice(0, 10); // Format YYYY-MM-DD
      updatedVisits[index].date = nextDate;
    }

  }

// ✅ NEW: If changing date of first visit, recalculate all later static visits
if (field === 'date' && index === 0) {
  for (let i = 1; i < updatedVisits.length; i++) {
    if (updatedVisits[i].schedule_type === 'static') {
      const prevDateStr = updatedVisits[i - 1]?.date;
      const intervalDays = parseInt(updatedVisits[i].interval);

      if (prevDateStr && !isNaN(intervalDays)) {
        const prevDate = new Date(prevDateStr);
        prevDate.setDate(prevDate.getDate() + intervalDays);
        updatedVisits[i].date = prevDate.toISOString().slice(0, 10);
      }
    }
  }
}

    setVisits(updatedVisits);
  };

  const viewSubmit = async () => {
    //alert(JSON.stringify(allResponses));
    sessionStorage.setItem('allVisitResponses', JSON.stringify(allResponses));
  }

  const handleSubmit = async () => {
     const token  = localStorage.getItem('authToken'); 
  const endpoint = `${main_url}/api/v1/project-schedules/`; 

  /*
   const scdata =
   {
     "planned_date":"2025-08-06",
     "project": 22,
     "interval":"3",
     "window_size":"NA",
     "schedule_type":"static"
   };
   */

  try {
    for (const visit of visits) {
      const isDynamic = visit.schedule_type === 'dynamic';

      const payload = {
        "schedule_type": visit.schedule_type || 'static',
        "planned_date":  null,
        "project": projectId,
        "interval":     isDynamic ? 'NA' : visit.interval || 'NA',
        "window_size": isDynamic ? 'NA' : visit.buffer || 'NA',
      };

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Failed to submit visit: ${JSON.stringify(payload)}`);
      }

      const result = await response.json();
      allResponses.push(result);
      //alert(JSON.stringify(allResponses));
      console.log(`Visit submitted:`, allResponses);
    }

    alert('All visits submitted successfully!'); 
     onClose?.(); 

  } catch (error) {
    console.error('Error submitting visits:', error);
    alert('Failed to submit one or more visits.');
  }
};

useEffect(() => {
  const num = parseInt(totalvisits) || 0;

  if (num > 0) {
    const defaultVisits = Array.from({ length: num }, (_, i) => ({
      schedule_type: 'static',
      date: i === 0 ? new Date().toISOString().slice(0, 10) : '',
      interval: '',
      buffer: '',
    }));
    setVisits(defaultVisits);

    setFormData((prev) => ({
      ...prev,
      number_of_visits: num,
    }));
  }
}, [totalvisits]);


  return (
    <Box 
     sx={{
            borderRadius:"10",
            bgcolor: "#f0f2f0"
          }}
          
          > 
      {/* === Timeline Section === */}
      <br></br>
      <Typography variant="h5" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
        Schedule Setting
      </Typography>
      <Divider sx={{ mb: 2, borderBottomWidth: 2 }} />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Number of Visits"
            name="number_of_visits"
            
            value={formData.number_of_visits}
           
            sx={{ width: '150px' }} 
            size="small"
             disabled
          >
            <br></br>
            
          </TextField>
        </Grid>
      </Grid>

      {/* === Dynamic Visit Boxes === */}
      {visits.map((visit, index) => {

         const shouldHideDate = visits.slice(0, index + 1).some(v => v.schedule_type === 'dynamic');
return (
        <Box 
          key={index}
          sx={{
            border: '1px solid #ccc',
            borderRadius: 2,
            padding: 2,
            mt: 2,
            bgcolor: "#fafafc"
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            Visit {index + 1}
          </Typography>

 {/* === Visit Type Selector === */}
    <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
      <Grid item xs={12} sm={6}>

 <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
      Schedule Type
    </Typography>

{index === 0 ? (
        <Typography variant="body2" sx={{ fontWeight: '', ml:4 }}>
               Static
        </Typography>
        ) : (

        <RadioGroup 
          row
          value={visit.schedule_type || 'static'}
          onChange={(e) => handleVisitChange(index, 'schedule_type', e.target.value)}
        >
           
          <FormControlLabel value="static" control={<Radio />} label="Static" />
          <FormControlLabel value="dynamic" control={<Radio />} label="Dynamic" />
        </RadioGroup>
        
)}

<br></br>
      </Grid>
    </Grid>

 {/* === Show fields only for Static Visit Type === */}
    {visit.schedule_type !== 'dynamic' && (


          <Grid container spacing={2}>
             {!shouldHideDate && (

            <Grid item xs={12} sm={4}>
              <TextField
                label="Visit Date"
                type="text"
                value={visit.date}
                onChange={(e) => handleVisitChange(index, 'date', e.target.value)}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true, readOnly:true }}
                style={{ display: 'none' }}
                   InputProps={
                  index === 0
                    ? {
                        //readOnly: true,
                        style: {
                          backgroundColor: '#f5f5f5',
                          cursor: 'not-allowed',
                          display: 'none'
                        },
                      }
                    : {}
                }

              />
            </Grid>
)}

           {index !== 0 && (

            <Grid item xs={12} sm={4}>

              <Tooltip title="Enter duration (days) between previous schedule to current" placement="top" arrow
              componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '1rem',       // bigger font
                  backgroundColor: '#333', // dark background
                  color: '#fff',           // white text
                  padding: '10px 15px',
                  borderRadius: '8px',
                },
                className: 'custom-tooltip', // optional CSS class
              },
            arrow: {
              sx: {
                color: '#333',           // arrow color
              },
            },
            }}
              >
              <TextField
                label="Interval"
                
                value={visit.interval}
                onChange={(e) => handleVisitChange(index, 'interval', e.target.value)}
                fullWidth
                size="small"
                sx={{ width: '100px' }} 
                required
              > 

              </TextField>
              </Tooltip>
            </Grid>
)}

 {index !== 0 && (

            <Grid item xs={12} sm={4}>
              <TextField
                label="Buffer Window"
                
                value={visit.buffer}
                onChange={(e) => handleVisitChange(index, 'buffer', e.target.value)}
                fullWidth
                size="small"
                sx={{ width: '100px' }} 
                required
              >
              
                        </TextField>
                     </Grid> 
             )}
                    </Grid>

                )   // end of cond
            }
        <br></br>
        </Box>
);
})}
        

<Button variant="contained" color="primary" sx={{ mt: 3 }} onClick={handleSubmit} >
          Save Schedules
</Button>
<Tab></Tab>
</Box>

  );
};

export default TimelineSection;
